var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8327 2.49967H16.666C17.5827 2.49967 18.3327 3.24967 18.3327 4.16634V17.4997C18.3327 18.4163 17.5827 19.1663 16.666 19.1663H3.33268C2.41602 19.1663 1.66602 18.4163 1.66602 17.4997V4.16634C1.66602 3.24967 2.41602 2.49967 3.33268 2.49967H4.16602V0.833008H5.83268V2.49967H14.166V0.833008H15.8327V2.49967ZM3.33268 17.4997H16.666V6.66634H3.33268V17.4997Z",
    fill: "#8993A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.9a850a717644a9822889b3f449ce7393.svg";
export { ForwardRef as ReactComponent };